module.exports = __webpack_public_path__ + "static/media/checkmark.7917ee8e.svg";